import React, { FormEvent, useEffect } from 'react';
import { useContextSelector } from 'use-context-selector';

import Button from '../../components/Button';
import TagInfo from '../../components/TagInfo';
import HeadTitle from '../../components/HeadTitle';
import FooterWrapper from '../../components/FooterWrapper';
import LoadingOverlay from '../../components/LoadingOverlay';
import SystemUnavailable from '../../components/SystemUnavailable';
import ModalNoEligibility from '../../components/ModalNoEligibility';
import { ModalProductNotCovered } from '../../components/ModalProductNotCovered';

import { PatientForm } from './Components/PatientForm';
import { GenericModalActions } from './Components/GenericModalActions';

const alertEinsteinIcon =
  'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/warningBlue.svg';
import { PlatformContext } from '../../contexts/PlatformContext';
import { ServiceContext } from '../../contexts/ServiceContext';
import { RouterContext } from '../../contexts/RouterContext';
import { useGenericModal } from '../../hooks/useGenericModal';
import { PAGES } from '../../Router/pages';

import PatientIdentificationViewModel from './index.model';
import * as S from './styles';
import { useMainRouter } from '../../Router/pageComponents';

const PatientIdentification: React.FC = () => {
  const { selectedService } = useContextSelector(ServiceContext, state => state);

  const { clearData } = useContextSelector(PlatformContext, state => state);

  const { goTo, goBack, history } = useContextSelector(RouterContext, state => state);

  const { addGenericModals } = useGenericModal({});

  const {
    formik,
    updateFormPatient,
    loading,
    setLoading,
    genericModal,
    patientSelected,
    selectedProduct,
    routeProductSelector,
    handleSchedulePatient,
    isModalSystemUnavailableVisible,
    setIsModalSystemUnavailableVisible,
    isModalNoEligibility,
    setIsModalNoEligibility,
    isModalProductNotCoveredVisible,
    setIsModalProductNotCoveredVisible,
    validateGenderCatalogGenericRules
  } = PatientIdentificationViewModel();

  useEffect(() => {
    if (patientSelected) {
      updateFormPatient(patientSelected);
    }
  }, []);

  useEffect(() => {
    if (patientSelected) {
      updateFormPatient(patientSelected);
    }
  }, [patientSelected?.idPatient]);

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    formik.submitForm();
  };

  function checkButtonEnable(): boolean {
    const errors = formik.errors;

    const values: { [index: string]: string } = formik.values;

    const requiredFields = ['document', 'documentType', 'name', 'email', 'birthDateDate', 'phone'];

    const hasEmptyFields = requiredFields.some(field => !values[field]);

    const hasErrors = Object.values(errors).some(error => !!error);

    return hasEmptyFields || hasErrors;
  }

  const { goBack: mainRouterGoBack } = useMainRouter();

  function handleGoBack() {
    if (history.length === 1) return mainRouterGoBack();
    else goBack();
  }

  return (
    <S.Container onSubmit={e => handleSubmit(e)}>
      <S.FieldsWrapper>
        <HeadTitle
          title="Informe os dados do paciente"
          goBack={() => {
            clearData();
            handleGoBack();
          }}
        />
        <div className="info-wrapper">
          <TagInfo
            icon={<img src={alertEinsteinIcon} alt="alert icon" />}
            info="Os dados do paciente são confidenciais e de uso exclusivo dos serviços Einstein."
          />
        </div>

        <PatientForm formik={formik} validateGenderCatalogGenericRules={validateGenderCatalogGenericRules} />
      </S.FieldsWrapper>

      <FooterWrapper>
        <S.ButtonWrapper>
          <Button title="Continuar" type="button" disabled={checkButtonEnable()} onClick={() => formik.submitForm()} />
        </S.ButtonWrapper>
      </FooterWrapper>
      <LoadingOverlay loading={loading} />
      <GenericModalActions
        goTo={goTo}
        genericModal={genericModal}
        selectedProduct={selectedProduct}
        patientSelected={patientSelected}
        selectedService={selectedService}
        routeProductSelector={routeProductSelector}
        handleSchedulePatient={handleSchedulePatient}
        addAdditionalInformations={addGenericModals}
        setLoading={setLoading}
      />
      <SystemUnavailable
        visible={isModalSystemUnavailableVisible}
        onClose={() => {
          setIsModalSystemUnavailableVisible(false);
        }}
      />
      <ModalNoEligibility
        visible={isModalNoEligibility}
        onClose={() => {
          setIsModalNoEligibility(false);
        }}
      />
      <ModalProductNotCovered
        visible={isModalProductNotCoveredVisible}
        onClose={() => setIsModalProductNotCoveredVisible(false)}
      />
    </S.Container>
  );
};

export default PatientIdentification;
